import { useLocation } from 'react-router-dom';
import { useOmniFilter, type OmniFilterState } from '@plerionhq/design-system';
import { isGlobalFilterRoute } from './global-filter-routes';

/** One object, so a blank state is referentially stable across renders. */
const EMPTY_FILTER: OmniFilterState = {};

/**
 * The global filter's stored state, blank on a page that does not carry the
 * control. The selection is kept in the browser, so reading it raw would
 * narrow a page with nothing on screen to show or clear it.
 */
export const useScopedOmniFilter = (): OmniFilterState => {
  const { omniFilterState } = useOmniFilter();
  const { pathname, search } = useLocation();
  if (!isGlobalFilterRoute(pathname, search)) {
    return EMPTY_FILTER;
  }
  return omniFilterState;
};
